export const REGRAS_ACORDO_PIX_TITLE = 'Regras para Pagamento de Acordo com o Pix';
export const ARQUIVO_MENSAGEM_QUITACAO_DEVEDOR_TITLE = 'Arquivo de Mensagem de Quitação para o Devedor';
export const REGRAS_PAGAMENTO_CARTAO_TITLE = 'Regras para Pagamento de Acordo com o Cartão de Crédito';
export const PRAZO_EXPIRACAO_PIX_FIELD = 'Prazo de expiração do Pix';
export const VALOR_MAX_PROCESSO_FIELD = 'Valor máximo do Processo';
export const PRAZO_EXPIRACAO_ACESSO_FIELD = 'Prazo de expiração para acesso ao site e pagamento do Acordo';
export const ARQUIVO_MENSAGEM_EXTRA_EMAIL_DEVEDOR_TITLE = 'Arquivo de Mensagem Extra do E-mail para o Devedor';
